import {
  CreateAccountData,
  CreateAccountsResponse,
  AccountsAPI,
  UpdateAccountRequest,
} from "../../../api/accounts";
import { MessageResponse } from "../../../api/common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Stakeholder } from "../../../api/stakeholders";

export const addAccounts = createAsyncThunk<
  CreateAccountsResponse,
  {
    case_id: string;
    accounts: CreateAccountData[];
    stakeholders?: Stakeholder[];
  },
  { rejectValue: string }
>("accounts/add", async (params, { rejectWithValue }) => {
  try {
    return await AccountsAPI.add(
      params.case_id,
      params.accounts,
      params.stakeholders,
    );
  } catch {
    return rejectWithValue("Failed to add accounts");
  }
});

export const updateAccount = createAsyncThunk<
  MessageResponse,
  {
    case_id: string;
    account_number: string;
    request: UpdateAccountRequest;
  },
  { rejectValue: string }
>("accounts/update", async (params, { rejectWithValue }) => {
  try {
    return await AccountsAPI.update(
      params.case_id,
      params.account_number,
      params.request,
    );
  } catch {
    return rejectWithValue("Failed to update account");
  }
});
